import { runtimeConfig } from "./runtime-config";

type WhatsAppUrlEnv = {
  readonly VITE_CONVEX_SITE_URL?: string;
  readonly VITE_APP_CSITE_DOMAIN_SUFFIX?: string;
};

const WEBHOOK_PATH = "/webhooks/whatsapp";

const browserEnv: WhatsAppUrlEnv = {
  VITE_CONVEX_SITE_URL: import.meta.env.VITE_CONVEX_SITE_URL,
  VITE_APP_CSITE_DOMAIN_SUFFIX: import.meta.env.VITE_APP_CSITE_DOMAIN_SUFFIX,
};

function normalizeBaseUrl(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

function isAbsoluteHttpsUrl(value: string): boolean {
  try {
    const parsed = new URL(value);
    return (
      parsed.protocol === "https:" &&
      parsed.username === "" &&
      parsed.password === "" &&
      parsed.pathname === "/" &&
      parsed.search === "" &&
      parsed.hash === ""
    );
  } catch {
    return false;
  }
}

function deriveSiteUrl(
  env: WhatsAppUrlEnv,
  simpleappId: string,
): string | null {
  const siteUrl = env.VITE_CONVEX_SITE_URL?.trim();
  if (siteUrl) {
    const normalized = normalizeBaseUrl(siteUrl);
    return isAbsoluteHttpsUrl(normalized) ? normalized : null;
  }

  const appId = simpleappId.trim();
  const domainSuffix = env.VITE_APP_CSITE_DOMAIN_SUFFIX?.trim();
  if (!appId || !domainSuffix) return null;

  const suffix = domainSuffix.replace(/^\.+|\.+$/g, "");
  if (
    !/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(
      suffix,
    )
  ) {
    return null;
  }
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(appId)) return null;
  const derived = `https://${appId}.${suffix}`;
  return isAbsoluteHttpsUrl(derived) ? derived : null;
}

export function getWhatsAppWebhookUrl(
  env: WhatsAppUrlEnv = browserEnv,
  simpleappId: string = runtimeConfig.simpleappId,
): string | null {
  const siteUrl = deriveSiteUrl(env, simpleappId);
  if (!siteUrl) {
    console.warn("[Frontend][WhatsApp] Convex site URL is not exposed to the browser");
    return null;
  }
  return `${siteUrl}${WEBHOOK_PATH}`;
}
